<template>
  <div class="innermap">
    <el-amap
      :vid="'bmap-vue'"
    >
      
    </el-amap>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {},
    props: [
    ],
    data () {
      return {
        markers: []
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      aab () {
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    },
    mounted () {
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .innermap {
    position: relative;
    width: 100%;
    height: 229px;
  }
</style>




// WEBPACK FOOTER //
// inner-map.vue?09f8d1ee